import {type PropsWithChildren} from 'react'
import {tv, type VariantProps} from 'tailwind-variants'
import {gridItem} from '~/design-system/foundations'
import {type HgWYSIWYGType} from '../../types'

const bodyVariants = tv({
  base: 'text-text-default',
  variants: {
    variant: {
      'body-1': '',
      'body-2': '',
      'body-3': '',
    },
    wysiwygType: {
      article: '',
      legal: '',
    },
  },
  compoundVariants: [
    {
      wysiwygType: 'article',
      variant: 'body-1',
      class: 'tiempos-body-1',
    },
    {
      wysiwygType: 'article',
      variant: 'body-2',
      class: 'tiempos-body-2',
    },
    {
      wysiwygType: 'article',
      variant: 'body-3',
      class: 'tiempos-body-3',
    },
    {
      wysiwygType: 'legal',
      variant: 'body-1',
      class: 'arcadia-body-1',
    },
    {
      wysiwygType: 'legal',
      variant: 'body-2',
      class: 'arcadia-body-2',
    },
    {
      wysiwygType: 'legal',
      variant: 'body-3',
      class: 'arcadia-body-3',
    },
  ],
})

type BodyTextVariant = VariantProps<typeof bodyVariants>['variant']

export type BodyTextProps = PropsWithChildren<{
  variant: BodyTextVariant
  wysiwygType: HgWYSIWYGType
  className?: string
}>

export const BodyText = ({
  variant = 'body-2',
  wysiwygType,
  className,
  children,
}: BodyTextProps) => {
  return (
    <p className={bodyVariants({variant, wysiwygType, class: className})}>
      {children}
    </p>
  )
}

export const HgWYSIWYGBodyText = (props: BodyTextProps) => {
  return (
    <BodyText
      {...props}
      className={gridItem({size: 'heading', className: props.className})}
    />
  )
}
